import type { ActivityFeedItem } from '../service/ActivityFeedItem';
import {
    ActivityFeedStorageItem,
    ActivityFeedV2StorageItem,
    ActivityStateFlags,
} from '../service/ActivityFeedStorageItem';
import type { FileActivityPayload, UserAtMentionedPayload } from '../service/SocialActivityPayload';

function isActivityFeedV2(item: ActivityFeedStorageItem): item is ActivityFeedV2StorageItem {
    return item['activityState'] !== undefined;
}

export function IsFileActivityPayload(
    payload: UserAtMentionedPayload | FileActivityPayload
): payload is FileActivityPayload {
    return (
        payload['actor'] !== undefined &&
        payload['fileDetails'] !== undefined &&
        payload['data'] !== undefined
    );
}

function getActivityState(item: ActivityFeedStorageItem) {
    if (isActivityFeedV2(item)) {
        return {
            isSeen: (item.activityState & ActivityStateFlags.IsSeen) === ActivityStateFlags.IsSeen,
            isRead: (item.activityState & ActivityStateFlags.IsRead) === ActivityStateFlags.IsRead,
            isDismissed:
                (item.activityState & ActivityStateFlags.IsDismissed) ===
                ActivityStateFlags.IsDismissed,
        };
    } else {
        return {
            isSeen: item.isSeen,
            isRead: item.isRead,
            isDismissed: item.isDismissed,
        };
    }
}

export function getActivityFeedItem(item: ActivityFeedStorageItem): ActivityFeedItem {
    const { isSeen, isRead, isDismissed } = getActivityState(item);
    return {
        /*
            Typescript won't let us assign the broad ActivityType and any payload to the
            union of the specific type/payload pairs. To get rid of this type assertion,
            we would need to check that the server has correctly paired the item type and payload
           */
        type: item.type as any,
        payload: JSON.parse(item.activityFeedItemPayload),
        id: item.id,
        isSeen: isSeen,
        isRead: isRead,
        isDismissed: isDismissed,
        timestamp: item.timestamp,
    };
}
